import { render, staticRenderFns } from "./stripe-setting.vue?vue&type=template&id=54ecca8e&scoped=true&"
import script from "./stripe-setting.vue?vue&type=script&lang=js&"
export * from "./stripe-setting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ecca8e",
  null
  
)

export default component.exports